// frontend/src/hooks/useNavigation.js
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { tenantNameToSlug } from '../utils/tenantSlug';
import {
  buildTenantNavigationTarget,
  splitTenantRelativePath,
} from '../utils/tenantNavigationTarget';

export const useNavigation = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  const getTenantPath = (path) => {
    if (!user || !user.tenant_name) {
      return '/login';
    }

    const urlFriendlyTenantName = tenantNameToSlug(user.tenant_name);
    const { pathnamePart, search } = splitTenantRelativePath(path);

    return `/${urlFriendlyTenantName}/${pathnamePart}${search}`;
  };

  const getTenantNavigationTarget = (path) =>
    buildTenantNavigationTarget(path, getTenantPath);

  const navigateToTenant = (path, options) => {
    navigate(getTenantNavigationTarget(path), options);
  };

  return {
    getTenantPath,
    getTenantNavigationTarget,
    navigateToTenant,
    navigate // Still expose original navigate for non-tenant routes
  };
};